import Image from "next/image";
import React, { useState } from "react";

const UspSolutionMobile = () => {
  const [isPopupOpen, setPopupOpen] = useState({ open: false, code: "" });

  const openPopup = (code: string) => {
    setPopupOpen({ open: true, code: code });
  };

  const closePopup = () => {
    setPopupOpen({ open: false, code: "" });
  };

  return (
    <>
      <div className="mx-auto w-full xl:px-0 md:px-6 lg:!px-6 px-5 md:bg-bottom bg-center bg-white pt-[30px] pb-[30px] relative">
        <Image
          src="/accounting/bg_logo_stem.png"
          alt="MS in Accounting (STEM)"
          className="absolute left-0 bottom-0 w-full"
          width={430}
          height={300}
          priority
        />
        <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 text-[#030F1C] z-20 relative md:block flex flex-col justify-center items-center">
          <h2 className="font-semibold md:text-[36px] text-[24px] text-[#05192E] text-center md:mb-[40px] mb-[30px] leading-normal">
            Here’s Our Solution: US STEM
            <span className="md:pb-0 inline-block border-[#ca7216] border-b-2">
              Pathway for Global Accountants
            </span>
          </h2>
          <div
            className="border-[1px] border-black relative w-[328px] h-[182px] flex items-center justify-center mt-2"
            onClick={() => {
              openPopup("VWzM-bqssTk");
            }}
          >
            <Image
              src="/images/accounting/usp/solutions.png"
              alt="Accountants"
              className="cursor-pointer w-full h-full"
              width={490}
              height={285}
            />

            <div className="flex items-center justify-center md:rounded-[15px] rounded-[15px] absolute left-0 right-0 bottom-[32%]">
              <Image
                src="/images/accounting/usp/video-icon.png"
                alt="Accountants"
                className="cursor-pointer w-[50px]"
                width={110}
                height={110}
              />
            </div>
          </div>
        </div>
      </div>
      {isPopupOpen.open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999]">
          <div className="bg-white p-1 shadow-lg relative rounded-[14px] md:w-[auto] w-[85%]">
            <button
              onClick={closePopup}
              className="mt-4 bg-red-700 text-white px-3 py-1 rounded absolute right-[-15px] top-[-30px]"
            >
              ✕
            </button>
            <iframe
              className="lg:w-[600px] md:w-[500px] md:h-[280px] rounded-[14px] lg:h-[320px] h-[220px]"
              width="100%"
              height="320"
              src={`https://www.youtube.com/embed/${isPopupOpen.code}`}
              title="YouTube video player"
              allow="accelerometer; autoplay; climd:oard- pb-14write; encrypted-media; gyroscope; picture-in-picture; web-share"
            ></iframe>
          </div>
        </div>
      )}
    </>
  );
};

export default UspSolutionMobile;
